// Progressive enhancement: the studio photograph and full page work without JS.
document.querySelectorAll('[data-zees-gallery]').forEach(gallery => {
  if (gallery.dataset.zeesReady) return;
  const image = gallery.querySelector('[data-zees-main-image]');
  const buttons = [...gallery.querySelectorAll('button[data-zees-image]')];
  const status = gallery.querySelector('[data-zees-gallery-status]');
  if (!image || !buttons.length) return;
  gallery.dataset.zeesReady = 'true';
  let selection = 0;
  buttons.forEach(button => button.addEventListener('click', async () => {
    const requested = ++selection;
    const candidate = new Image();
    candidate.src = button.dataset.zeesImage;
    try { await candidate.decode(); } catch {
      if (requested === selection && status) status.textContent = 'This view could not load. The current photograph is still available.';
      return;
    }
    if (requested !== selection) return;
    image.src = candidate.src;
    image.alt = button.dataset.zeesAlt;
    buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    if (status) status.textContent = `${button.getAttribute('aria-label')} selected.`;
  }));
});
